import { parse } from 'yaml'
import { SIGHTMAP_DOC, type SightmapDoc } from '../guidance/polish/sightmap/schema'
import { definitionLocation, flatTargetCandidates, flatTargetDefinitions } from '../guidance/polish/sightmap/resolve-definition'
import type { ComponentTarget } from '../guidance/app-tools/component-target'
import type { AppArtifactBundle } from '../guidance/app-tools/artifact-schema'

const SightmapFileSchema = SIGHTMAP_DOC.extend({ views: SIGHTMAP_DOC.shape.views.default([]) })

/** The saved map: every `.sightmap/*.yaml` file merged, as the loader merges them. */
function bundleSightmap(bundle: AppArtifactBundle | undefined): SightmapDoc {
  const doc: SightmapDoc & { components: NonNullable<SightmapDoc['components']> } = { views: [], components: [] }
  for (const file of bundle?.files ?? []) {
    if (!file.path.startsWith('.sightmap/') || !file.path.endsWith('.yaml')) continue
    try {
      const parsed = SightmapFileSchema.safeParse(parse(file.contents))
      if (!parsed.success) continue
      doc.views.push(...parsed.data.views)
      doc.components.push(...parsed.data.components ?? [])
    } catch { /* Missing or malformed historical map: show the saved reference instead. */ }
  }
  return doc
}

export function toolTargetDetails(bundle: AppArtifactBundle | undefined, step: { component?: ComponentTarget; surfaceId?: string; controlId?: string }) {
  const doc = bundleSightmap(bundle)
  const targets = step.component ? [step.component] : step.controlId ? flatTargetCandidates(doc, step.controlId, step.surfaceId) : []
  const resolved = flatTargetDefinitions(doc, targets)
  if (resolved.length !== 1) return null
  const { reference, path } = resolved[0]!
  const location = definitionLocation(doc, reference.surfaceId, path)
  const viewId = location.kind === 'unique' ? location.hit.viewId : null
  return { surface: doc.views.find(view => view.id === viewId)?.name ?? null, path }
}
